/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TasksSideBarAliases {
  DATE_FILTER_FIELD = 'date-filter-field',
  FILTER = 'filter',
  FROM_DATE_FIELD = 'from-date-field',
  PANEL_0 = 'panel-0',
  PROGRESS_FILTER_AUTOCOMPLETE = 'progress-filter-autocomplete',
  PROGRESS_FILTER_FIELD = 'progress-filter-field',
  PROGRESS_FILTER_MAPPER = 'progress-filter-mapper',
  PROGRESS_FILTER_TEXT = 'progress-filter-text',
  SCHEDULE_TASKS_PROGRESS_CARD = 'schedule-tasks-progress-card',
  SCHEDULE_TYPE_AUTOCOMPLETE = 'schedule-type-autocomplete',
  SCHEDULE_TYPE_FIELD = 'schedule-type-field',
  SCHEDULE_TYPE_MAPPER = 'schedule-type-mapper',
  SCHEDULE_TYPE_TEXT = 'schedule-type-text',
  TASKS_CONTEXTUAL_BAR = 'tasks-contextual-bar',
  TASKS_PROGRESS_DECK = 'tasks-progress-deck',
  TASKS_PROGRESS_FETCH = 'tasks-progress-fetch',
  TASKS_PROGRESS_FETCH_PANEL = 'tasks-progress-fetch-panel',
  TASKS_SIDE_BAR_LAYOUT = 'tasks-side-bar-layout',
  VIEW_ALL_ACTION = 'view-all-action',
}
export { TasksSideBarAliases };
